import { createFileRoute } from "@tanstack/react-router";
import { JaziaSignUp } from "@/components/signup/JaziaSignUp";

export const Route = createFileRoute("/signup")({
  component: JaziaSignUp,
});
